/* eslint-disable */
export default {
  to: 'A:',
  transferTo: 'Transferir a',
  blindTransfer: 'Transferir',
  warmTransfer: 'Preguntar primero',
  enterNameOrNumber: 'Ingresar número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
